import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { SolutionPageStructuredData } from "../../config/StructuredData";

const ProfessionalServicesPage = () => (
  <>
    <SolutionPageStructuredData
      name="Workflow Management for Professional Service Teams"
      description="Simplifyte is workflow management software built for professional service teams — manage client work, deadlines, documents, reviews, approvals, audit trail and closure proof in one workspace."
      url="https://www.simplifyte.com/solutions/professional-services"
    />
    <HeaderMenu />

    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Solutions / Professional Services</p>
          <h1 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>
            Workflow Management Software for Professional Service Teams
          </h1>
          <p style={{ fontSize: "18px", opacity: 0.85, maxWidth: "700px", margin: "0 auto 32px" }}>
            Simplifyte is built for professional service teams that manage recurring client work — CA firms, tax consultants, advocates, consultants, IT service teams and more. One workspace for client-wise work, documents, deadlines, reviews, approvals, audit trail and closure proof.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
            <Link to="/pricing" style={{ border: "1px solid rgba(255,255,255,0.5)", color: "#fff", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>View Pricing</Link>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "28px", fontWeight: 700, color: "#093A5B", marginBottom: "12px" }}>Built for teams that manage recurring client work</h2>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7, marginBottom: "32px" }}>
            Generic project management tools are designed for one-off projects. Professional service teams handle recurring, period-based, client-specific work — where every engagement has a client, a period, a document status, a review, an approval, and a closure requirement. Simplifyte is designed for exactly this.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: "20px" }}>
            {[
              { title: "Client-wise work tracking", desc: "Every task belongs to a specific client. See all work for one client, or all clients for one period — instantly." },
              { title: "Period and FY-based workflows", desc: "Tag work to financial year, quarter, or month. Never lose track of which period's work is in which stage." },
              { title: "Document collection", desc: "Request, track, and remind clients for documents without managing a separate WhatsApp thread for each." },
              { title: "Structured review and approval", desc: "Define who reviews and who approves. Work moves through stages with a clear handoff and audit log at each step." },
              { title: "Deadline management", desc: "Internal and external deadlines are visible to everyone who needs to know. Automated reminders, not manual nudges." },
              { title: "Audit trail and closure proof", desc: "Every professional service engagement ends with documented proof of completion — for your protection and your client's confidence." },
            ].map((f, i) => (
              <div key={i} style={{ background: "#f8fafc", padding: "20px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                <CheckCircle2 size={22} color="#093A5B" style={{ marginBottom: "10px" }} />
                <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1e293b", marginBottom: "8px" }}>{f.title}</h3>
                <p style={{ fontSize: "14px", color: "#64748b", lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 24px", background: "#f8fafc" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: "22px", fontWeight: 700, color: "#093A5B", marginBottom: "16px" }}>Simplifyte works for</h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
            {["CA Firms","Tax Consultants","Advocates","Management Consultants","IT Service Teams","Compliance Teams","Audit Teams","Finance Teams"].map((t,i)=>(
              <span key={i} style={{ background: "#e0f2fe", color: "#0369a1", padding: "8px 16px", borderRadius: "100px", fontSize: "14px", fontWeight: 500 }}>{t}</span>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "28px", fontWeight: 700, marginBottom: "16px" }}>Replace WhatsApp, Excel and email chaos with one structured workspace</h2>
        <p style={{ opacity: 0.8, marginBottom: "28px", fontSize: "16px" }}>Book a 20-minute demo and see Simplifyte in action for your team.</p>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "14px 32px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>
          Book a Demo <ArrowRight size={16} />
        </Link>
      </section>
    </main>

    <CustomFooter />
  </>
);

export default ProfessionalServicesPage;
